var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';
var DelayTimeCheckDirective = /** @class */ (function () {
    function DelayTimeCheckDirective() {
        this.minTime = 0;
        this.maxTime = 60;
    }
    DelayTimeCheckDirective_1 = DelayTimeCheckDirective;
    DelayTimeCheckDirective.prototype.validate = function (control) {
        if (!control.value && control.value !== 0) {
            return { 'delayTime': 'error' };
        }
        var value = +control.value;
        if (!Number.isInteger(value)) {
            return { 'delayTime': 'error' };
        }
        if (value < this.minTime || value > this.maxTime) {
            return { 'delayTime': 'error' };
        }
        return undefined;
    };
    var DelayTimeCheckDirective_1;
    __decorate([
        Input()
    ], DelayTimeCheckDirective.prototype, "minTime", void 0);
    __decorate([
        Input()
    ], DelayTimeCheckDirective.prototype, "maxTime", void 0);
    DelayTimeCheckDirective = DelayTimeCheckDirective_1 = __decorate([
        Directive({
            selector: '[delayTimeCheck]',
            providers: [{
                    provide: NG_VALIDATORS,
                    useExisting: DelayTimeCheckDirective_1,
                    multi: true
                }]
        })
    ], DelayTimeCheckDirective);
    return DelayTimeCheckDirective;
}());
export { DelayTimeCheckDirective };
